import Axios from "axios";

const INITIAL_STATE = {
  representatives: {
    total: 0,
    perPage: 0,
    page: 0,
    lastPage: 0,
    data: [
      {
        id: null,
        name: null,
        phones: null,
        emails: null,
        cro: null,
        city: null,
        image_path: null,
        is_active: null,
      },
    ],
  },
};

export const updateRepresentatives = param => ({
  type: "SET_REPRESENTATIVES",
  payload: param,
});

export const getRepresentatives = (url, config) => (dispatch, getState) => {
  return Axios.get(url, config)
    .then(resp => {
      dispatch(updateRepresentatives(resp.data));
    })
    .catch(function (error) {});
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_REPRESENTATIVES":
      return { ...state, representatives: action.payload };
    default:
      return state;
  }
};
